// ISO country code → currency mapping (most common tourist destinations).
// Falls back to USD when unknown.
const MAP: Record<string, { currency: string; symbol: string }> = {
  US: { currency: "USD", symbol: "$" },
  CA: { currency: "CAD", symbol: "$" },
  MX: { currency: "MXN", symbol: "$" },
  BR: { currency: "BRL", symbol: "R$" },
  AR: { currency: "ARS", symbol: "$" },
  CL: { currency: "CLP", symbol: "$" },
  CO: { currency: "COP", symbol: "$" },
  PE: { currency: "PEN", symbol: "S/" },
  GB: { currency: "GBP", symbol: "£" },
  CH: { currency: "CHF", symbol: "Fr" },
  NO: { currency: "NOK", symbol: "kr" },
  SE: { currency: "SEK", symbol: "kr" },
  DK: { currency: "DKK", symbol: "kr" },
  IS: { currency: "ISK", symbol: "kr" },
  PL: { currency: "PLN", symbol: "zł" },
  CZ: { currency: "CZK", symbol: "Kč" },
  HU: { currency: "HUF", symbol: "Ft" },
  RO: { currency: "RON", symbol: "lei" },
  RU: { currency: "RUB", symbol: "₽" },
  TR: { currency: "TRY", symbol: "₺" },
  UA: { currency: "UAH", symbol: "₴" },
  JP: { currency: "JPY", symbol: "¥" },
  CN: { currency: "CNY", symbol: "¥" },
  KR: { currency: "KRW", symbol: "₩" },
  TW: { currency: "TWD", symbol: "NT$" },
  HK: { currency: "HKD", symbol: "HK$" },
  SG: { currency: "SGD", symbol: "S$" },
  TH: { currency: "THB", symbol: "฿" },
  VN: { currency: "VND", symbol: "₫" },
  ID: { currency: "IDR", symbol: "Rp" },
  MY: { currency: "MYR", symbol: "RM" },
  PH: { currency: "PHP", symbol: "₱" },
  IN: { currency: "INR", symbol: "₹" },
  AE: { currency: "AED", symbol: "د.إ" },
  SA: { currency: "SAR", symbol: "﷼" },
  IL: { currency: "ILS", symbol: "₪" },
  EG: { currency: "EGP", symbol: "£" },
  ZA: { currency: "ZAR", symbol: "R" },
  MA: { currency: "MAD", symbol: "د.م." },
  KE: { currency: "KES", symbol: "KSh" },
  AU: { currency: "AUD", symbol: "$" },
  NZ: { currency: "NZD", symbol: "$" },
};

const EURO_ZONE = new Set([
  "AT","BE","CY","DE","EE","ES","FI","FR","GR","IE","IT","LT","LU","LV","MT","NL","PT","SI","SK","HR","AD","MC","SM","VA",
]);

export function currencyForCountry(code: string): { currency: string; symbol: string } {
  const cc = code.toUpperCase();
  if (EURO_ZONE.has(cc)) return { currency: "EUR", symbol: "€" };
  return MAP[cc] ?? { currency: "USD", symbol: "$" };
}
